enum OrderPaymentDestination {
  None = 0,
  CreditCard = 1,
  EmployeeId = 2,
  Cashier = 3,
}

export { OrderPaymentDestination };
